var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@/ui-toolkit/elements/Icon/Icon';
import { colorTheme } from '@/ui-toolkit/mixin/colorTheme';
import { TableHeader } from '../TableRowContent';
var SortableTH = styled(TableHeader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n\n    cursor: pointer;\n    transition: 0.6s;\n\n    &:hover {\n        color: var(--td-col-hover);\n        transform: scale(1.01);\n    }\n\n    &:active ", " svg {\n        transition: 0.2s;\n        transform: scale(1.2);\n    }\n"], ["\n    ", ";\n\n    cursor: pointer;\n    transition: 0.6s;\n\n    &:hover {\n        color: var(--td-col-hover);\n        transform: scale(1.01);\n    }\n\n    &:active ", " svg {\n        transition: 0.2s;\n        transform: scale(1.2);\n    }\n"])), colorTheme({
    '--td-col-hover': { dark: 'var(--blue-12)', light: 'var(--blue-16)' },
}), Icon.Wrapper);
export var SortableHeader = function (_a) {
    var children = _a.children, isCurrentSort = _a.isCurrentSort, currentDirection = _a.currentDirection, onClick = _a.onClick;
    return (React.createElement(SortableTH, { onClick: onClick },
        children,
        isCurrentSort && (React.createElement(React.Fragment, null,
            currentDirection && React.createElement(Icon, { type: "md", name: "ExpandLess" }),
            !currentDirection && React.createElement(Icon, { type: "md", name: "ExpandMore" })))));
};
var templateObject_1;
